
<template>
	<v-container
		fluid
		class="d-flex align-center pa-0 justify-center"
		style="margin-bottom: -1.5vw;"
		:style="[
			bgColor === 'purple'
				? { backgroundColor: '#221551' }
				: bgColor === 'black'
				? { backgroundColor: '#000000' }
				: { backgroundColor: '#FFFFFF' }
		]"
	>
		<v-row class="d-flex flex-wrap .duo-custom-template-full">

			<!-- HEADER -->
			<v-col cols="12" style="margin-top: 1vw;" v-if="!isPreview">
				<v-row class="d-flex justify-space-between align-center">

					<v-col class="duo-custom justify-left align-center">
						<div
							style="font-family: AirNZ Sans Regular !important; color: #FFFFFF;"
							class="pl-10"
						>
							<h2>{{ title }}</h2>
						</div>
					</v-col>

					<v-col cols="auto" class="justify-right">
						<v-row class="d-flex justify-right no-gutters mr-10">

							<v-col class="duo-custom pr-3 d-flex align-center">
								<div
									v-html="page.valueMap.headerIconTitle"
									class="text-right align-center"
									style="font-family: AirNZ Sans Regular !important; color: #FFFFFF;"
								></div>
							</v-col>

							<v-col cols="auto" class="d-flex align-end">

								<v-avatar
									v-if="$root.isBlank(page.valueMap.headerIcon)"
									:color="parsedHeaderIconBackgroundColor"
									size="58"
									class="ml-auto"
								>
									<v-icon
										:color="parsedHeaderIconColor"
										size="27"
										class="duo-icon-training"
									></v-icon>
								</v-avatar>

								<v-img
									v-else
									:src="$base + '/asset/file/' + page.valueMap.headerIcon"
									width="60"
									class="ml-auto"
								></v-img>

							</v-col>

						</v-row>
					</v-col>

				</v-row>
			</v-col>

			<!-- CONTENT -->
			<v-col cols="12">

				<v-card
					width="100%"
					min-height="416"
					rounded="0"
					:elevation="0"
					:style="[
						bgColor === 'purple'
							? { backgroundColor: '#221551' }
							: bgColor === 'black'
							? { backgroundColor: '#000000' }
							: { backgroundColor: '#FFFFFF' }
					]"
				>

					<v-card-text class="ma-0 pa-0">

						<v-form
							v-model="validForm"
							ref="form"
							lazy-validation
						>

							<v-container class="d-flex align-center" style="height: auto">

								<v-row class="px-0 py-0">

									<!-- QUESTION IMAGE -->
									<v-col
										cols="12"
										class="d-flex justify-left align-center text-wrap"
										style="padding: 0px;"
									>

										<v-card
											class="d-flex justify-center align-center"
											style="border-radius: 0px; padding-left: 0px; margin-left: -10vw"
											:style="{
												backgroundImage:
													'url(' +
													($root.isBlank(imageNameQuestion)
														? $bucket + '/image/training-tiles/DuoTraining.jpg'
														: '\'' + imageNameQuestion + '\'') +
													')',
												backgroundSize: 'cover'
											}"
											min-width="110vw"
											min-height="400px"
											elevation="0"
											dark
										>

											<span
												:style="{
													marginLeft: width < 1600 ? '-12.5vw' : '0vw'
												}"
												style="
													width: 50vw;
													padding: 30px;
													line-height: 40px;
													font-weight: bold;
													font-size: 35px;
													font-family: AirNZ Black Italic;
													display: table;
													list-style-position: inside;
												"
												v-html="question"
											></span>

										</v-card>

									</v-col>

									<!-- ANSWER TEXTAREA -->
									<v-col cols="9" class="px-10 pt-10">

										<v-textarea
											v-model="responseText"
											label="Answer in 50 words or less"
											outlined
											auto-grow
											rows="5"
											:dark="bgColor !== 'white'"
											:disabled="isSubmitted" 
											:hide-details="wordCount <= responseLimit" 
											:rules="[(v) => !!v || 'Please enter your answer', (v) => (v && wordCount <= responseLimit) || 'Max '+responseLimit+' words']" 
											@input="onInputAnswer"
										></v-textarea>

									</v-col>

								</v-row>

							</v-container>

						</v-form>

					</v-card-text>

				</v-card>

			</v-col>

			<!-- FOOTER -->
			<v-col cols="12" class="d-flex justify-end">

				<v-row class="d-flex flex-wrap">

					<v-col
						cols="11"
						class="d-flex justify-end pr-0"
						style="margin-bottom: 13vw;"
					>

						<div>

							<v-btn
								v-if="!isSubmitted"
								style="background-color:#04A0A8; border-color: #04A0A8;"
								:disabled="!isValidAnswer"
								height="50"
								width="193"
								elevation="0"
								outlined
								class="white--text ml-auto text-transform-none"
								:right="true"
								@click="submit()"
							>
								Submit
							</v-btn>

							<v-btn
								v-else
								style="background-color:#04A0A8; border-color: #04A0A8;"
								height="50"
								width="193"
								elevation="0"
								outlined
								class="white--text ml-auto text-transform-none"
								:right="true"
								@click="nextPage()"
							>
								Next
							</v-btn>

						</div>

					</v-col>

				</v-row>

			</v-col>

		</v-row>
	</v-container>
</template>

<script>
/* eslint-disable no-console */

export default {
	props: {
		page: {
			type: Object,
			required: true
		},
		isPreview: {
			type: Boolean,
			required: true,
			default: false
		},
		bgColor: {
			type: String,
			required: true
		},
		question: {
			type: String,
			required: true
		},
		imageNameQuestion: {
			type: String,
			required: true
		}
	},

	computed: {
		parsedHeaderIconColor() {
			if (this.page.valueMap.headerIconColor) {
				return this.page.valueMap.headerIconColor.hexa;
			} else {
				return "#FFFFFFFF";
			}
		},

		parsedHeaderIconBackgroundColor() {
			if (this.page.valueMap.headerIconBackgroundColor) {
				return this.page.valueMap.headerIconBackgroundColor.hexa;
			} else {
				return "#440099";
			}
		},

		wordCount: function() {
			if (this.responseText.trim() === '') {
				return 0; // No words if input is empty or only spaces
			}
			// Split the input into words by spaces and count them
			return this.responseText.trim().split(/\s+/).length;
		},

		isValidAnswer() {
			return this.wordCount > 0 && this.wordCount <= 50;
		}
	},

	data() {
		return {
			validForm: true,
			width: 0,
			responseText: "",
			responseLimit: 50,
			isSubmitted: false,
		};
	},

	mounted() {
		this.width = window.innerWidth;

		if (this.page.valueMap.responseText) {
			this.responseText = this.page.valueMap.responseText;
		}
	},

	methods: {

		onInputAnswer() {

			this.page.valueMap.responseText = this.responseText;
		},

		submit() {
			// Jalankan validasi form internal Vuetify secara eksplisit
			const isFormValid = this.$refs.form.validate();

			if (isFormValid && this.isValidAnswer) {
				if (!this.isPreview) {
					this.page.valueMap.responseText = this.responseText;
					this.$emit("submit");
					this.isSubmitted = true;
				}
			}
		},

		previousPage() {
			if (!this.isPreview) {
				this.$emit("previousPage");
			}
		},

		nextPage() {
			if (!this.isPreview) {
				this.responseText = "-";
				this.isSubmitted = false;
				this.$emit("nextPage");
			}
		},
	}
};
</script>

<style scoped>
.transparent-card {
	background-color: rgba(255, 255, 255, 0.5) !important;
}

.form-group {
	height: 80vh;
}

.v-application .title {
	font-size: 26px !important;
	font-weight: 600;
	letter-spacing: 1px !important;
}

.quiz-50-textarea ::v-deep textarea {
	font-size: 20px !important;
	line-height: 32px !important;
}

.quiz-50-textarea ::v-deep .v-label {
	font-size: 18px !important;
}
</style>

